<template>
    <v-container class="pa-2 triple-view" fluid grid-list-sm >        
        <v-card class="shadow-none">                
            <v-card-text>
                <Environment v-bind:showAssignment="true" v-bind:dcontent="dcontent"  v-bind:taskIndex="taskIndex"  v-bind:activity_type="activity_type" v-bind:startTime="startTime"/>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
//import {mapGetters} from 'vuex'
import * as logs from '../../assets/log_process.js'
import Environment from '../../components/lab/environment.vue'
 
export default {   
    data() {
        return {
            startTime : null,
        }
    },
    components : {
        Environment
    },
    props: { 
        dcontent: Object,
        taskIndex: Number,
        activity_type: String
    },
    methods: {
    },
    mounted() {
        this.startTime = new Date()
        logs.write_to_log('open', 'course', this.dcontent.course_id, 'task', this.dcontent.task_id, 0, this.$store.getters.getAxiosConfig)
    },
    beforeDestroy() {
        logs.write_to_log('close', 'course', this.dcontent.course_id, 'task', this.dcontent.task_id, Math.floor((new Date() - this.startTime)/1000 + 0.5), this.$store.getters.getAxiosConfig)
    }
}
</script>

<style>

</style>